import React from 'react';

export default function ProfileDetailTables({
  profile = {},
  onOpenAddModal,
  onDeleteItem,
}) {
  const family = profile.family || [];
  const qualifications = profile.qualifications || [];
  const experience = profile.experience || [];
  const skills = profile.skills || [];
  const hobbies = profile.hobbies || [];
  const projects = profile.projects || [];
  const languages = profile.languages || [];
  const medical = profile.medical || [];
  const nominees = profile.nominees || [];
  const documents = profile.documents || [];
  const balances = profile.balances || [];
  const salary = profile.salary || [];

  return (
    <div className="space-y-6">
      {/* 1. Family Information */}
      <div className="rounded-2xl border border-outline-variant/25 bg-surface-container-lowest shadow-xs overflow-hidden">
        <div className="flex items-center justify-between px-6 py-3.5 bg-surface-container-low border-b border-outline-variant/20">
          <div className="flex items-center gap-2">
            <span className="material-symbols-outlined text-lg text-primary">diversity_1</span>
            <h3 className="text-xs font-extrabold uppercase tracking-wider text-black">
              Family Information
            </h3>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs font-sans tabular-nums font-semibold text-slate-500">
              {family.length} entries
            </span>
            <button
              type="button"
              onClick={() => onOpenAddModal('family')}
              className="inline-flex items-center gap-1 text-xs font-bold text-primary hover:underline cursor-pointer"
            >
              <span className="material-symbols-outlined text-sm">add</span>
              <span>Add</span>
            </button>
          </div>
        </div>

        {family.length === 0 ? (
          <div className="p-6 text-center text-xs text-slate-500 font-medium">No Record Found</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm border-collapse">
              <thead>
                <tr className="border-b border-outline-variant/20 bg-surface-container-low/30 text-[11px] font-extrabold uppercase text-slate-600">
                  <th className="py-2.5 px-6 w-16">Action</th>
                  <th className="py-2.5 px-6">Full Name</th>
                  <th className="py-2.5 px-6">Qualification</th>
                  <th className="py-2.5 px-6">Contact No</th>
                  <th className="py-2.5 px-6 text-right">Age</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-outline-variant/15 text-xs">
                {family.map((f) => (
                  <tr key={f.id} className="hover:bg-surface-container-low/40">
                    <td className="py-3 px-6">
                      <button
                        type="button"
                        onClick={() => onDeleteItem('family', f.id)}
                        className="text-slate-400 hover:text-red-600 transition cursor-pointer"
                        title="Delete"
                      >
                        <span className="material-symbols-outlined text-base">delete</span>
                      </button>
                    </td>
                    <td className="py-3 px-6 font-bold text-on-surface">{f.fullName}</td>
                    <td className="py-3 px-6 text-slate-600">{f.qualification || '—'}</td>
                    <td className="py-3 px-6 font-sans tabular-nums font-medium text-slate-700">{f.contactNo || '—'}</td>
                    <td className="py-3 px-6 text-right font-sans tabular-nums font-bold text-on-surface">{f.age}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* 2. Qualification Information */}
      <div className="rounded-2xl border border-outline-variant/25 bg-surface-container-lowest shadow-xs overflow-hidden">
        <div className="flex items-center justify-between px-6 py-3.5 bg-surface-container-low border-b border-outline-variant/20">
          <div className="flex items-center gap-2">
            <span className="material-symbols-outlined text-lg text-primary">school</span>
            <h3 className="text-xs font-extrabold uppercase tracking-wider text-black">
              Qualification Information
            </h3>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs font-sans tabular-nums font-semibold text-slate-500">
              {qualifications.length} entries
            </span>
            <button
              type="button"
              onClick={() => onOpenAddModal('qualifications')}
              className="inline-flex items-center gap-1 text-xs font-bold text-primary hover:underline cursor-pointer"
            >
              <span className="material-symbols-outlined text-sm">add</span>
              <span>Add</span>
            </button>
          </div>
        </div>

        {qualifications.length === 0 ? (
          <div className="p-6 text-center text-xs text-slate-500 font-medium">No Record Found</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm border-collapse">
              <thead>
                <tr className="border-b border-outline-variant/20 bg-surface-container-low/30 text-[11px] font-extrabold uppercase text-slate-600">
                  <th className="py-2.5 px-6 w-16">Action</th>
                  <th className="py-2.5 px-6">Degree / Certificate</th>
                  <th className="py-2.5 px-6">Institution / University</th>
                  <th className="py-2.5 px-6">Passing Year</th>
                  <th className="py-2.5 px-6 text-right">Percentage / Grade</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-outline-variant/15 text-xs">
                {qualifications.map((q) => (
                  <tr key={q.id} className="hover:bg-surface-container-low/40">
                    <td className="py-3 px-6">
                      <button
                        type="button"
                        onClick={() => onDeleteItem('qualifications', q.id)}
                        className="text-slate-400 hover:text-red-600 transition cursor-pointer"
                        title="Delete"
                      >
                        <span className="material-symbols-outlined text-base">delete</span>
                      </button>
                    </td>
                    <td className="py-3 px-6 font-bold text-on-surface">{q.degree}</td>
                    <td className="py-3 px-6 text-slate-600">{q.institution}</td>
                    <td className="py-3 px-6 font-sans tabular-nums font-semibold text-slate-700">{q.passingYear}</td>
                    <td className="py-3 px-6 text-right font-sans tabular-nums font-bold text-emerald-600">{q.percentage}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* 3. Experience Information */}
      <div className="rounded-2xl border border-outline-variant/25 bg-surface-container-lowest shadow-xs overflow-hidden">
        <div className="flex items-center justify-between px-6 py-3.5 bg-surface-container-low border-b border-outline-variant/20">
          <div className="flex items-center gap-2">
            <span className="material-symbols-outlined text-lg text-primary">work_history</span>
            <h3 className="text-xs font-extrabold uppercase tracking-wider text-black">
              Experience Information
            </h3>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs font-sans tabular-nums font-semibold text-slate-500">
              {experience.length} entries
            </span>
            <button
              type="button"
              onClick={() => onOpenAddModal('experience')}
              className="inline-flex items-center gap-1 text-xs font-bold text-primary hover:underline cursor-pointer"
            >
              <span className="material-symbols-outlined text-sm">add</span>
              <span>Add</span>
            </button>
          </div>
        </div>

        {experience.length === 0 ? (
          <div className="p-6 text-center text-xs text-slate-500 font-medium">No Record Found</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm border-collapse">
              <thead>
                <tr className="border-b border-outline-variant/20 bg-surface-container-low/30 text-[11px] font-extrabold uppercase text-slate-600">
                  <th className="py-2.5 px-6 w-16">Action</th>
                  <th className="py-2.5 px-6">Previous Employer</th>
                  <th className="py-2.5 px-6">Designation</th>
                  <th className="py-2.5 px-6 text-right">Duration</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-outline-variant/15 text-xs">
                {experience.map((exp) => (
                  <tr key={exp.id} className="hover:bg-surface-container-low/40">
                    <td className="py-3 px-6">
                      <button
                        type="button"
                        onClick={() => onDeleteItem('experience', exp.id)}
                        className="text-slate-400 hover:text-red-600 transition cursor-pointer"
                      >
                        <span className="material-symbols-outlined text-base">delete</span>
                      </button>
                    </td>
                    <td className="py-3 px-6 font-bold text-on-surface">{exp.employer}</td>
                    <td className="py-3 px-6 text-slate-600">{exp.designation}</td>
                    <td className="py-3 px-6 text-right font-sans tabular-nums font-bold text-primary">{exp.duration}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* 4. Skills Information */}
      <div className="rounded-2xl border border-outline-variant/25 bg-surface-container-lowest shadow-xs overflow-hidden">
        <div className="flex items-center justify-between px-6 py-3.5 bg-surface-container-low border-b border-outline-variant/20">
          <div className="flex items-center gap-2">
            <span className="material-symbols-outlined text-lg text-primary">psychology</span>
            <h3 className="text-xs font-extrabold uppercase tracking-wider text-black">
              Skills Information
            </h3>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs font-sans tabular-nums font-semibold text-slate-500">
              {skills.length} entries
            </span>
            <button
              type="button"
              onClick={() => onOpenAddModal('skills')}
              className="inline-flex items-center gap-1 text-xs font-bold text-primary hover:underline cursor-pointer"
            >
              <span className="material-symbols-outlined text-sm">add</span>
              <span>Add</span>
            </button>
          </div>
        </div>

        {skills.length === 0 ? (
          <div className="p-6 text-center text-xs text-slate-500 font-medium">No Record Found</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm border-collapse">
              <thead>
                <tr className="border-b border-outline-variant/20 bg-surface-container-low/30 text-[11px] font-extrabold uppercase text-slate-600">
                  <th className="py-2.5 px-6 w-16">Action</th>
                  <th className="py-2.5 px-6">Skill Name</th>
                  <th className="py-2.5 px-6">Proficiency</th>
                  <th className="py-2.5 px-6 text-right">Years of Exp</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-outline-variant/15 text-xs">
                {skills.map((s) => (
                  <tr key={s.id} className="hover:bg-surface-container-low/40">
                    <td className="py-3 px-6">
                      <button
                        type="button"
                        onClick={() => onDeleteItem('skills', s.id)}
                        className="text-slate-400 hover:text-red-600 transition cursor-pointer"
                      >
                        <span className="material-symbols-outlined text-base">delete</span>
                      </button>
                    </td>
                    <td className="py-3 px-6 font-bold text-on-surface">{s.skillName}</td>
                    <td className="py-3 px-6">
                      <span className="rounded-md bg-blue-50 px-2 py-0.5 font-bold text-[11px] text-blue-700 border border-blue-200">
                        {s.proficiency}
                      </span>
                    </td>
                    <td className="py-3 px-6 text-right font-sans tabular-nums font-bold text-slate-700">{s.years}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* 5. Hobbies Information */}
      <div className="rounded-2xl border border-outline-variant/25 bg-surface-container-lowest shadow-xs overflow-hidden">
        <div className="flex items-center justify-between px-6 py-3.5 bg-surface-container-low border-b border-outline-variant/20">
          <div className="flex items-center gap-2">
            <span className="material-symbols-outlined text-lg text-primary">interests</span>
            <h3 className="text-xs font-extrabold uppercase tracking-wider text-black">
              Hobbies Information
            </h3>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs font-sans tabular-nums font-semibold text-slate-500">
              {hobbies.length} entries
            </span>
            <button
              type="button"
              onClick={() => onOpenAddModal('hobbies')}
              className="inline-flex items-center gap-1 text-xs font-bold text-primary hover:underline cursor-pointer"
            >
              <span className="material-symbols-outlined text-sm">add</span>
              <span>Add</span>
            </button>
          </div>
        </div>

        {hobbies.length === 0 ? (
          <div className="p-6 text-center text-xs text-slate-500 font-medium">No Record Found</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm border-collapse">
              <thead>
                <tr className="border-b border-outline-variant/20 bg-surface-container-low/30 text-[11px] font-extrabold uppercase text-slate-600">
                  <th className="py-2.5 px-6 w-16">Action</th>
                  <th className="py-2.5 px-6">HobbiesName</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-outline-variant/15 text-xs">
                {hobbies.map((h) => (
                  <tr key={h.id} className="hover:bg-surface-container-low/40">
                    <td className="py-3 px-6">
                      <button
                        type="button"
                        onClick={() => onDeleteItem('hobbies', h.id)}
                        className="text-slate-400 hover:text-red-600 transition cursor-pointer"
                      >
                        <span className="material-symbols-outlined text-base">delete</span>
                      </button>
                    </td>
                    <td className="py-3 px-6 font-bold text-on-surface">{h.name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* 6. Language Information */}
      <div className="rounded-2xl border border-outline-variant/25 bg-surface-container-lowest shadow-xs overflow-hidden">
        <div className="flex items-center justify-between px-6 py-3.5 bg-surface-container-low border-b border-outline-variant/20">
          <div className="flex items-center gap-2">
            <span className="material-symbols-outlined text-lg text-primary">translate</span>
            <h3 className="text-xs font-extrabold uppercase tracking-wider text-black">
              Language Information
            </h3>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs font-sans tabular-nums font-semibold text-slate-500">
              {languages.length} entries
            </span>
            <button
              type="button"
              onClick={() => onOpenAddModal('languages')}
              className="inline-flex items-center gap-1 text-xs font-bold text-primary hover:underline cursor-pointer"
            >
              <span className="material-symbols-outlined text-sm">add</span>
              <span>Add</span>
            </button>
          </div>
        </div>

        {languages.length === 0 ? (
          <div className="p-6 text-center text-xs text-slate-500 font-medium">No Record Found</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm border-collapse">
              <thead>
                <tr className="border-b border-outline-variant/20 bg-surface-container-low/30 text-[11px] font-extrabold uppercase text-slate-600">
                  <th className="py-2.5 px-6 w-16">Action</th>
                  <th className="py-2.5 px-6">Language</th>
                  <th className="py-2.5 px-6 text-center">Read</th>
                  <th className="py-2.5 px-6 text-center">Write</th>
                  <th className="py-2.5 px-6 text-center">Speak</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-outline-variant/15 text-xs">
                {languages.map((l) => (
                  <tr key={l.id} className="hover:bg-surface-container-low/40">
                    <td className="py-3 px-6">
                      <button
                        type="button"
                        onClick={() => onDeleteItem('languages', l.id)}
                        className="text-slate-400 hover:text-red-600 transition cursor-pointer"
                      >
                        <span className="material-symbols-outlined text-base">delete</span>
                      </button>
                    </td>
                    <td className="py-3 px-6 font-bold text-on-surface">{l.language}</td>
                    <td className="py-3 px-6 text-center font-bold text-emerald-600">{l.read ? 'True' : 'False'}</td>
                    <td className="py-3 px-6 text-center font-bold text-emerald-600">{l.write ? 'True' : 'False'}</td>
                    <td className="py-3 px-6 text-center font-bold text-emerald-600">{l.speak ? 'True' : 'False'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* 7. Salary Details matching Screenshot 3 */}
      <div className="rounded-2xl border border-outline-variant/25 bg-surface-container-lowest shadow-xs overflow-hidden">
        <div className="flex items-center justify-between px-6 py-3.5 bg-surface-container-low border-b border-outline-variant/20">
          <div className="flex items-center gap-2">
            <span className="material-symbols-outlined text-lg text-primary">payments</span>
            <h3 className="text-xs font-extrabold uppercase tracking-wider text-black">
              Salary Details
            </h3>
          </div>
          <span className="text-xs font-sans tabular-nums font-semibold text-slate-500">
            {salary.length} entries
          </span>
        </div>

        {salary.length === 0 ? (
          <div className="p-6 text-center text-xs text-slate-500 font-medium">No Record Found</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm border-collapse">
              <thead>
                <tr className="border-b border-outline-variant/20 bg-surface-container-low/30 text-[11px] font-extrabold uppercase text-slate-600">
                  <th className="py-2.5 px-6">EmpID</th>
                  <th className="py-2.5 px-6">Name</th>
                  <th className="py-2.5 px-6">PayHeadType</th>
                  <th className="py-2.5 px-6">EffectiveFrom</th>
                  <th className="py-2.5 px-6 text-right">Amount</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-outline-variant/15 text-xs">
                {salary.map((sal) => (
                  <tr key={sal.id} className="hover:bg-surface-container-low/40">
                    <td className="py-3 px-6 font-sans tabular-nums font-semibold text-slate-600">{sal.empId}</td>
                    <td className="py-3 px-6 font-bold text-on-surface">{sal.name}</td>
                    <td className="py-3 px-6 font-semibold text-primary">{sal.payHeadType}</td>
                    <td className="py-3 px-6 font-sans tabular-nums font-medium text-slate-700">{sal.effectiveFrom}</td>
                    <td className="py-3 px-6 text-right font-sans tabular-nums font-bold text-sm text-emerald-600">
                      {sal.formattedAmount || `₹${Number(sal.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
